import { render, staticRenderFns } from "./VoiceRecognition.vue?vue&type=template&id=cc05a94c&scoped=true"
import script from "./VoiceRecognition.vue?vue&type=script&lang=js"
export * from "./VoiceRecognition.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecognition.vue?vue&type=style&index=0&id=cc05a94c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc05a94c",
  null
  
)

export default component.exports